export const HTML_ERROR_FALLBACK_MESSAGE = 'ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง';

export function isHtmlErrorMessage(value: string): boolean {
  const trimmedValue = value.trim().toLowerCase();

  return (
    trimmedValue.startsWith('<!doctype html') ||
    trimmedValue.startsWith('<html') ||
    /<\/?(html|head|body|title|style|script|pre)(\s|>|\/)/i.test(value)
  );
}

export function getSafeErrorText(value: unknown): string {
  if (typeof value !== 'string') {
    return '';
  }

  const message = value.trim();

  if (message === '') {
    return '';
  }

  return isHtmlErrorMessage(message) ? HTML_ERROR_FALLBACK_MESSAGE : message;
}
